import type { ReactNode } from 'react';

export const symbol_page_header: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M150-780q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h660q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Zm630 100q24 0 42 18t18 42v440q0 24-18 42t-42 18H180q-24 0-42-18t-18-42v-440q0-24 18-42t42-18h600Zm0 60H180v440h600v-440Zm-600 0v440-440Z"
		/>
	</svg>
);
